import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, CardHeader, CardFooter } from 'reactstrap'
import { ApiService } from 'services'
import Header from '../../components/Headers/Header'
import Pagination from '../../components/Pagination'
import Table from './Table'
import Search from './Search'
import Filters from './Filters'
import { useUser } from 'context/UserContext'

function List () {
  const { listOptions, setListOptions } = useUser();

  const [isLoading, setIsLoading] = useState(true)

  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)

  const initialOptions = listOptions?.matriculates_ethics ? listOptions.matriculates_ethics : {
    sort: {
      field: 'created_at',
      dir: -1
    },
    page: 1,
    limit: 50,
    search: '',
    state_id: 1
  }

  // Opciones de paginacion, filtro y orden del listado
  const [currentOptions, setCurrentOptions] = useState(initialOptions)

  const fetchData = async (newOptions) => {
    // Merge de las nuevas opciones con las viejas
    const options = Object.assign({}, currentOptions, newOptions)

    setIsLoading(true)

    // Hacemos la petición
    const res = await ApiService.getAll('matriculates/ethics', options)

    // Guardamos las opciones
    setCurrentOptions(options)
    setListOptions({
      ...listOptions,
      matriculates_ethics: options
    })

    // Recuperamos algunos datos de los resultados
    const { rows, count } = res.payload
    setData(rows)
    setTotal(count)

    // Terminamos la carga
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const changePage = (page) => {
    fetchData({
      page
    })
  }

  const changeOrder = (field, dir) => {
    fetchData({
      sort: {
        field,
        dir
      }
    })
  }

  const changeFilter = (key, value) => {
    fetchData({
      [key]: value
    })
  }

  const search = (query) => {
    fetchData({
      search: query
    })
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Filters changeFilter={ changeFilter } currentOptions={ currentOptions } />
            <Search onSearch={ search } currentQuery={ currentOptions.search } />

            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col md='8'>
                    <h3 className="mb-0">Lista de Solicitudes de Certificados de Ética</h3>
                  </Col>
                </Row>
              </CardHeader>
              <Table id="matriculates-table" items={ data } isLoading={ isLoading } changeOrder={ changeOrder } currentOrder={ currentOptions?.sort } />
              <CardFooter className="py-4">
                <Row>
                  <Col sm={6}></Col>
                  <Col sm={6} className="d-flex justify-content-center d-sm-block">
                    <Pagination page={ currentOptions?.page } count={ total } onChangePage={ changePage } limit={ currentOptions?.limit } />
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default List
